$(function () {
  // VYHLADAVANIE V OBSAHU
  var catalogSearch = $("#catalogSearch");
  var topSearchForm = $("#topSearchForm");
  var currentRequest = null;

  if (catalogSearch.length) {
    var autocompletePopup = $('<div class="search" id="autocompletePopup"></div>')
      .html(
        '<div class="search__empty">' +
          __("Hľadanému výrazu nevyhovuje žiaden záznam") +
          "</div>" +
          '<div class="search__categories">' +
          '<div class="search__title">' +
          __("Kategórie") +
          "</div>" +
          '<div class="search__categories-results">' +
          "</div>" +
          "</div>" +
          '<div class="search__products">' +
          '<div class="search__title">' +
          __("Produkty") +
          "</div>" +
          '<div class="search__products-results">' +
          "</div>" +
          '<p class="search__more"><button class="button button--full-width" onclick="$(\'#catalogSearch\').closest(\'form\').submit()">' +
          __("Zobraziť viac") +
          "</button></p>" +
          "</div>"
      )
      .hide()
      .insertAfter("#catalogSearch");

    catalogSearch
      .on("keyup", function () {
        if (catalogSearch.data("useElastic") == 1) {
          if (catalogSearch.val()) {
            delay(function () {
              catalogSearchRequest();
            }, 200);
          }
        }
      })

      .on("focus", function () {
        if (catalogSearch.data("useElastic") == 1) {
          if (catalogSearch.val()) {
            delay(function () {
              catalogSearchRequest();
            }, 200);
          }
        }
      })
      .attr("autocomplete", "off");

    function catalogSearchRequest() {
      currentRequest = $.ajax({
        url: "/autocomplete/",
        data: {
          q: catalogSearch.val(),
        },
        dataType: "json",
        beforeSend: function () {
          if (currentRequest != null) {
            currentRequest.abort();
          }
        },
        success: function (response) {
          var empty = autocompletePopup.find(".search__empty");
          var products = autocompletePopup.find(".search__products > .search__products-results").html("");
          var categories = autocompletePopup.find(".search__categories > .search__categories-results").html("");

          var maxPerItem = 10,
            item,
            pr = [],
            cat = [];
          var prTemplate =
            '<a class="search__product" href="/{{url}}">' +
            '<div class="search__product-img">' +
            '<img src="{{picture}}" />' +
            "</div>" +
            '<div class="search__product-desc">' +
            '<div class="search__product-title">{{label}}</div> ' +
            '<div class="search__product-category">{{ordernr}}</div> ' +
            "</div>" +
            '<div class="search__product-price">{{price}}</div>' +
            "</a>";
          var catTemplate = '<div class="search__category"><a href="/{{id}}/" class="search__category-link">{{label}}</a></div>';

          products.next().hide();
          categories.next().hide();
          if (response.items !== undefined) {
            while (response.items.length) {
              item = response.items.shift();
              if (item.type === "product") {
                if (pr.length >= maxPerItem) {
                  products.next().show();
                  continue;
                }

                var el = prTemplate;
                var oldprice = item.oldprice ? item.oldprice.priceFormat() + " " + currencySign(item.currency) : "";
                var price = item.unitprice ? item.unitprice.priceFormat() + " " + currencySign(item.currency) : "";
                pr.push(
                  el
                    .replace(/\{\{url\}\}/g, item.url)
                    .replace(/\{\{ordernr\}\}/g, item.ordernr)
                    .replace(/\{\{id\}\}/g, item.id)
                    .replace(/\{\{label\}\}/g, item.label)
                    .replace(/\{\{price\}\}/g, price)
                    .replace(/\{\{oldprice\}\}/g, oldprice)
                    .replace(/\{\{picture\}\}/g, item.picture)
                );
              } else if (item.type === "category") {
                if (cat.length >= 6) {
                  categories.next().show();
                  continue;
                }
                var el = catTemplate;
                cat.push(el.replace(/\{\{id\}\}/g, item.url).replace(/\{\{label\}\}/g, item.label));
              }
            }
          }
          if (pr.length > 0) {
            products.html(pr.join(""));
            products.parent().show();
          } else {
            products.parent().hide();
          }

          if (cat.length > 0) {
            categories.html(cat.join(""));
            categories.parent().show();
          } else {
            categories.parent().hide();
          }

          if (pr.length > 0 || cat.length > 0) {
            empty.hide();
          } else {
            empty.show();
          }

          var query = catalogSearch.val().trim();
          var matched =
            products.highlight(query, "search__highlight") +
            categories.highlight(query, "search__highlight");
          // celá fráza nikde nesedí → fallback na jednotlivé slová
          if (!matched) {
            var terms = query.split(" ");
            for (var key in terms) {
              if (terms[key]) {
                products.highlight(terms[key], "search__highlight");
                categories.highlight(terms[key], "search__highlight");
              }
            }
          }

          autocompletePopup.show();
        },
      });
    }

    $(window)
      .on("click", function (e) {
        if (!$(e.target).closest(catalogSearch).length && !$(e.target).closest(autocompletePopup).length) {
          autocompletePopup.hide();
        }
      })
      .on("resize", function () {
        autocompletePopup.hide();
      });
  }
});

var delay = (function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

String.prototype.priceFormat = function () {
  var ps = "" + (Math.round(this * 100) / 100).toFixed(2);
  return ps.replace(".", ",");
};

Number.prototype.priceFormat = function () {
  var ps = "" + (Math.round(this * 100) / 100).toFixed(2);
  return ps.replace(".", ",");
};

var currencySign = function (currency) {
  var sign = currency;
  switch (currency.toUpperCase()) {
    case "EUR":
      sign = "€";
      break;
    default:
  }
  return sign;
};

$.fn.highlight = function (pat, className) {
  if (className == undefined) {
    className = "search__highlight";
  }
  var total = 0;
  function innerHighlight(node, pat) {
    var skip = 0;
    pat = pat.removeAccents().toUpperCase();
    if (node.nodeType == 3) {
      var pos = node.data.removeAccents().toUpperCase().indexOf(pat);
      if (pos >= 0) {
        var spannode = document.createElement("span");
        spannode.className = className;
        var middlebit = node.splitText(pos);
        var endbit = middlebit.splitText(pat.length);
        var middleclone = middlebit.cloneNode(true);
        spannode.appendChild(middleclone);
        middlebit.parentNode.replaceChild(spannode, middlebit);
        total++;
        skip = 1;
      }
    } else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
      for (var i = 0; i < node.childNodes.length; ++i) {
        i += innerHighlight(node.childNodes[i], pat);
      }
    }
    return skip;
  }
  if (this.length && pat && pat.length) {
    this.each(function () {
      innerHighlight(this, pat.toUpperCase());
    });
  }
  return total;
};

$.fn.removeHighlight = function (className) {
  if (className == undefined) {
    className = "search__highlight";
  }

  return this.find("span." + className)
    .each(function () {
      this.parentNode.firstChild.nodeName;
      with (this.parentNode) {
        replaceChild(this.firstChild, this);
        normalize();
      }
    })
    .end();
};

String.prototype.removeAccents = function () {
  return this.toLowerCase()
    .replace(/[áàãâä]/gi, "a")
    .replace(/[čç]/gi, "c")
    .replace(/[ď]/gi, "d")
    .replace(/[éèê]/gi, "e")
    .replace(/[íìïî]/gi, "i")
    .replace(/[ľĺ]/gi, "l")
    .replace(/[ñ]/gi, "n")
    .replace(/[óòöôõ]/gi, "o")
    .replace(/[ř]/gi, "r")
    .replace(/[š]/gi, "s")
    .replace(/[ť]/gi, "t")
    .replace(/[úùüûů]/gi, "u")
    .replace(/[ž]/gi, "z")
    .replace(/[^a-zA-Z0-9]/g, " ");
};
